import store from '../redux/store';
import { batchActions } from 'redux-batched-actions';
import client from './client';
import seedrandom from 'seedrandom';
import LZString from 'lz-string'

import * as Colyseus from "../colyseus.js/lib"; // not necessary if included via <script> tag.

// const host = window.location.href.indexOf('localhost') === -1 ? 'https://coly.settle-gliese.com' : 'ws://localhost:80';
const host = 'https://coly.settle-gliese.com';

export const colyClient = new Colyseus.Client(host);

import { STAIRCASE_UP_KEY, STAIRCASE_DOWN_KEY, MINE_WALL_KEY, drawMine, drawMineEntrance } from './mine-geography';
import { 
    selectCharacter,
    selectCharacters,
    selectTiles,
    selectMaterialTypes,
    selectTileTypes,
    selectPlantTypes,
    selectMineralTypes,
    selectToolTypes,
    selectMetalTypes,
    selectKeyTypes,
    selectMachineTypes,
    selectFurnitureTypes,
    selectConstructionTypes,
    selectWritingSurfaceTypes,
    selectWritingImplementTypes,
    selectWeaponTypes,
    selectArmourTypes,
    selectClothingTypes,
    selectJewelleryTypes,
    selectFoodTypes,
    selectLockTypes,
    selectAnimalTypes,
    selectPlantProducts,
    selectConstructionRecipes,
    selectBoatTypes,
    selectTentTypes,
    selectWorkshopTypes,
    selectWagonTypes,
    selectBrainchipTypes,
    selectUser
} from '../redux/selectors';

import { updateVisionRadius } from '../redux/actions/clock.actions';
import { getMessagesAsync } from '../redux/actions/messages.actions';
import { startNewGame } from '../redux/actions/user.actions';
import { loadPanelAsync, loadPanelSuccess } from '../redux/actions/panel.actions';
import { clearAllTiles, loadTilesAsync, loadTilesFinished, loadTilesSuccess } from '../redux/actions/tile.actions';

import { clearStairs } from '../redux/actions/stair.actions';

import { getFoodSuccess, getCharacterFoodAsync, addFoodToTileAsync, eatFoodAsync, deleteFoodAsync, addFoodToCharacterAsync } from '../redux/actions/food.actions';
import { getInventorySuccess, getInventoryAsync, addMaterialToTileAsync, addMaterialToCharacterAsync } from '../redux/actions/inventory.actions';
import { tileTypes, createTileAsync } from '../redux/actions/tile.actions';
import { getMineralsSuccess, getMineralsAsync, addMineralToTileAsync, addMineralToCharacterAsync } from '../redux/actions/mineral.actions';
import { getToolsSuccess, getToolsAsync, addToolToTileAsync, addToolToCharacterAsync } from '../redux/actions/tool.actions';
import { getMetalsSuccess, getMetalsAsync, addMetalToTileAsync, addMetalToCharacterAsync } from '../redux/actions/metal.actions';
import { getKeysSuccess, getKeysAsync, addKeyToTileAsync, copyKeyAsync, addKeyToCharacterAsync } from '../redux/actions/key.actions';
import { getWritingSurfacesSuccess, addWritingSurfaceToTileAsync, getWritingSurfacesAsync, editWritingSurfaceAsync, addWritingSurfaceToCharacterAsync } from '../redux/actions/writing-surface.actions';
import { getWritingImplementsSuccess, addWritingImplementToTileAsync, getWritingImplementsAsync, addWritingImplementToCharacterAsync } from '../redux/actions/writing-implement.actions';
import { getWeaponsSuccess, getWeaponsAsync, addWeaponToTileAsync, addWeaponToCharacterAsync } from '../redux/actions/weapon.actions';
import { getArmourSuccess, getArmourAsync, addArmourToTileAsync, addArmourToCharacterAsync } from '../redux/actions/armour.actions';
import { getClothingSuccess, getClothingAsync, addClothingToTileAsync, addClothingToCharacterAsync } from '../redux/actions/clothing.actions';
import { getJewellerySuccess, getJewelleryAsync, addJewelleryToTileAsync, addJewelleryToCharacterAsync } from '../redux/actions/jewellery.actions';
import { updateLobby, pollCharacterPanelIdAsync, getCharacterAsync, getCharacterSuccess, equipWeaponAsync, equipArmourAsync, equipClothingAsync, equipJewelleryAsync, unequipClothingAsync, unequipJewelleryAsync } from '../redux/actions/character.actions';
import { getCharactersAsync, getCharactersSuccess } from '../redux/actions/characters.actions';
import { addCharacterPanelSuccess } from '../redux/actions/character-panel.actions'
import {
    initialisingPanelStarted,
    initialisingPanelFinished,
    showQuantityInput,
    hideQuantityInput,
    chooseCharacterToGiveTo,
    hideCharacterList,
    closeInventory,
    showCharacterSelect,
    connected,
    connectionError,
    disconnected,
    reconnected,
} from '../redux/actions/keyboard-shortcuts.actions';
import { getDeadCharactersAsync, getDeadCharactersSuccess } from '../redux/actions/dead-characters.actions';
import { getConstructionsAsync, getConstructionsSuccess } from '../redux/actions/construction.actions';
import { getPlantsAsync, getPlantsSuccess } from '../redux/actions/plant.actions';
import { getMachinesAsync } from '../redux/actions/machine.actions';
import { getLocksSuccess, getLocksAsync } from '../redux/actions/lock.actions';
import { getFurnitureSuccess, getFurnitureAsync } from '../redux/actions/furniture.actions';
import { getAnimalsAsync, getAnimalsSuccess } from '../redux/actions/animal.actions';
import { getBoatsAsync, getBoatsSuccess } from '../redux/actions/boat.actions';
import { getBrainchipsAsync, getBrainchipsSuccess } from '../redux/actions/brainchip.actions';
import { getTentsSuccess, getTentsAsync } from '../redux/actions/tent.actions';
import { getWorkshopsAsync, getWorkshopsSuccess } from '../redux/actions/workshop.actions';
import { getWagonsAsync, getWagonsSuccess } from '../redux/actions/wagon.actions';
import { getCoinsAsync } from '../redux/actions/coin.actions';
import { getCharacterLevelsSuccess, getCharacterLevelsAsync } from '../redux/actions/character-levels.actions';
import { getPromptsAsync } from '../redux/actions/prompt.actions';
import { getDiaryEntriesAsync } from '../redux/actions/diary-entries.actions';
import { getOrganisationsSuccess } from '../redux/actions/organisation.actions'
import { getZonesSuccess } from '../redux/actions/zone.actions'
import { getOrdersSuccess, getCompletedOrdersSuccess } from '../redux/actions/order.actions'
import { getCharacterPanelsAsync } from '../redux/actions/character-panel.actions'
import { getCriminalsSuccess } from '../redux/actions/criminal.actions'

import WebhooksService from './Webhooks.service';

const LEAVING_CODES = {
    ON_PANEL_CHANGE: 4000
}

class PanelInitialisationService {
    isEverInitialised = false;
    isInitialised = false;
    isTilesInitialised = false;
    character;
    tiles;
    leaveExistingRoom = undefined;
    currentRoomId = undefined;
    reconnectionToken;

    dispatchQueue = [];
    allRooms = [];
    roomLeavingCallbacks = [];

    attempts = 0;

    addToQueue(action) {
        this.dispatchQueue.push(action);
    }

    constructor(tilemapService, audioService) {
        this.webhooksService = new WebhooksService(tilemapService, audioService);
        this.tilemapService = tilemapService;
        this.audioService = audioService;

        const state = store.getState();

        this.materialTypes = selectMaterialTypes(state);
        this.mineralTypes = selectMineralTypes(state);
        this.plantTypes = selectPlantTypes(state);
        this.tileTypes = selectTileTypes(state);
        this.toolTypes = selectToolTypes(state);
        this.metalTypes = selectMetalTypes(state);
        this.keyTypes = selectKeyTypes(state);
        this.machineTypes = selectMachineTypes(state);
        this.furnitureTypes = selectFurnitureTypes(state);
        this.constructionTypes = selectConstructionTypes(state);
        this.writingSurfaceTypes = selectWritingSurfaceTypes(state);
        this.writingImplementTypes = selectWritingImplementTypes(state);
        this.weaponTypes = selectWeaponTypes(state);
        this.armourTypes = selectArmourTypes(state);
        this.clothingTypes = selectClothingTypes(state);
        this.jewelleryTypes = selectJewelleryTypes(state);
        this.foodTypes = selectFoodTypes(state);
        this.lockTypes = selectLockTypes(state);
        this.animalTypes = selectAnimalTypes(state);
        this.boatTypes = selectBoatTypes(state);
        this.brainchipTypes = selectBrainchipTypes(state);
        this.tentTypes = selectTentTypes(state);
        this.workshopTypes = selectWorkshopTypes(state);
        this.wagonTypes = selectWagonTypes(state);
        this.plantProducts = selectPlantProducts(state);
        this.constructionRecipes = selectConstructionRecipes(state);
        this.user = selectUser(state);

        this.plantTypesDictionary = {}
        this.plantTypes.forEach(plantType => {
            this.plantTypesDictionary[plantType._id] = plantType
        });

        this.plantProductsDictionary = {}
        this.plantProducts.forEach(plantProduct => {
            if (!this.plantProductsDictionary[plantProduct.plantTypeId]) {
                this.plantProductsDictionary[plantProduct.plantTypeId] = [];
            }

            this.plantProductsDictionary[plantProduct.plantTypeId].push(plantProduct)
        });

        this.storeSubscription = store.subscribe(async () => {
            const state = store.getState();
            const updatedCharacter = selectCharacter(state);
            const characters = selectCharacters(state);

            if (this.character?._id && updatedCharacter._id !== this.character?._id) {
                this.character = updatedCharacter;

                this.joinRoomIfInLobby()
                return;
            }

            // If changed character
            if (updatedCharacter && (updatedCharacter?._id !== this.character?._id)) {
                this.character = updatedCharacter;
                this.joinRoomIfInLobby()
                return;
            }
        })

        store.dispatch(initialisingPanelStarted())
        this.joinLobby()
    }

    joinLobby() {
        colyClient.joinOrCreate("lobby", {
            jwt: window.localStorage.getItem('feathers-jwt')
        }).then(lobby => {
            lobby.onMessage("rooms", (rooms) => {
              this.allRooms = rooms;

              const room = rooms.find(room => room.metadata?.characterIds?.includes(this.character?._id));

              if (room) {
                if (room.roomId !== this.currentRoomId) {
                    this.joinPanel({
                        ...this.character,
                        panelId: room.metadata?.panelId,
                        z: room.metadata?.z
                    }, room.roomId);
                }
              } else {
                this.currentRoomId = undefined
              }

              const otherRooms = rooms.filter(room => !room.metadata?.characterIds?.includes(this.character?._id));

                this.leaveRooms();

                store.dispatch(updateLobby(this.allRooms))
            });

            lobby.onMessage("+", ([roomId, room]) => {
              const roomIndex = this.allRooms.findIndex((room) => room.roomId === roomId);
              if (roomIndex !== -1) {
                this.allRooms[roomIndex] = room;
             
              } else {
                this.allRooms.push(room);
              }

                store.dispatch(updateLobby(this.allRooms))

              if (room.metadata?.characterIds?.includes(this.character?._id)) {
                if (room.roomId !== this.currentRoomId) {
                    this.joinPanel({
                        ...this.character,
                        panelId: room.metadata?.panelId,
                        z: room.metadata?.z
                    }, room.roomId);
                }
              } else if (!room) {
                this.currentRoomId = undefined
              }
                this.leaveRooms();
            });
             
            lobby.onMessage("-", (roomId) => {
              this.allRooms = this.allRooms.filter((room) => room.roomId !== roomId);

                store.dispatch(updateLobby(this.allRooms))

              if (roomId === this.currentRoomId) {
                this.currentRoomId = undefined
              }

              this.leaveRooms();
            });

            lobby.onLeave(() => {
                this.joinLobby();
            })

            // lobby.onClose(() => {
            //     this.joinLobby();
            // })
        });
    }

    leaveRooms(isAllRooms) {
        const characterId = this.character?._id;

        if (!characterId) {
            return;
        }

        const roomsToLeave = this.allRooms.filter(room => {
            if (isAllRooms) {
                return true
            }
            return !room.metadata.characterIds.includes(characterId)
        })

        roomsToLeave.forEach(room => {
            const toLeave = this.roomLeavingCallbacks.filter(roomLeaving => roomLeaving.roomId === room.roomId);

            toLeave.forEach(toLeave => {
                if (toLeave.callback) {
                    console.log('should i really be leaving a room my man? ', room.roomId, room);
                    // toLeave.callback()
                }
                toLeave.callback = undefined;
            });
        })

        this.roomLeavingCallbacks = []
    }

    joinRoomIfInLobby(isSilentRejoin) {
        const allCharacterRooms = this.allRooms.filter(room => {
            return room.metadata.characterIds?.includes(this.character?._id)
        })

        const room = this.allRooms.find(room => {
            return room.metadata?.characterIds?.includes(this.character?._id)
        });

        this.leaveRooms(true);

        if (room && room.roomId !== this.currentRoomId) {
            this.joinPanel({
                ...this.character,
                panelId: room.metadata?.panelId,
                z: room.metadata?.z
            }, room.roomId, isSilentRejoin);
        } else if (!room) {
            this.currentRoomId = undefined;
        }
    }

    joinPanel(updatedCharacter, roomId, isSilentRejoin) {
        console.log('connecting: ', new Date().getTime());
        if (!isSilentRejoin) {
            store.dispatch(initialisingPanelStarted())
        }

        this.reconnectionToken = undefined

        if (this.currentRoomId === roomId) {
            return;
        }

        if (this.leaveExistingRoom) {
            this.leaveExistingRoom();
            this.leaveExistingRoom = undefined;
        }
        this.currentRoomId = roomId;

        if (!updatedCharacter.panelId) {
            throw new Error('Invalid character: ', updatedCharacter)
        }

        // console.log('connecting...', roomId)

        if (colyClient.room?.leave) {
            console.log('leaving: ', room.roomId);
            colyClient.room.leave(true);
        }

        console.log('connecting 2: ', new Date().getTime());

        colyClient.joinById(`${updatedCharacter.panelId}-${updatedCharacter.z}`, {
            panelId: updatedCharacter.panelId,
            characterId: updatedCharacter._id,
            z: updatedCharacter.z,
            userId: updatedCharacter.userId,
            jwt: window.localStorage.getItem('feathers-jwt')
        })
        .then(room => {
            console.log('connected: ', new Date().getTime());
            // console.log('connected! reconnectionToken: ', room.reconnectionToken);

            colyClient.room = room;

            const monitoringInterval = this.monitorConnection(room);

            this.reconnectionToken = room.reconnectionToken;

            room.onError((code, message) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.onError(", code, message);
                    if (!room._hasLeft) {
                        room._hasLeft = true
                        this.currentRoomId = undefined;
                        if (this.reconnectionToken) {
                            console.warn(new Date(), "⚠️ room.onError: reconnect", event);
                            colyClient.reconnect(this.reconnectionToken);
                        } else {
                            console.warn(new Date(), "⚠️ room.onError: joinRoomIfInLobby", event);
                            this.joinRoomIfInLobby(true)
                        }
                    }
                });
            })

            //https://docs.colyseus.io/server/room/#errorcode-message
            room.onLeave((code) => {
                // clearInterval(monitoringInterval);
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.onLeave(", code);
                });
                if (code > 1000) {
                    console.warn(new Date(), 'ON LEAVE: ', code);
                    // this.currentRoomId = undefined;
                    // this.joinRoomIfInLobby(true);

                    // console.log('...trying to rejoin...');
                    // if (!room._hasLeft) {
                    //     // colyClient.reconnect(this.reconnectionToken)
                    //   this.currentRoomId = undefined;
                    //   this.joinRoomIfInLobby(true);
                    // }
                } else {
                    console.warn(new Date(), 'ON LEAVE planned, do not reconnect: ', code);
                }

                // room._hasLeft = true;
            })

            room.connection.onclose = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.onclose", event);
                    // if (!room._hasLeft) {
                    //     room._hasLeft = true
                    //     this.currentRoomId = undefined;
                    //     if (this.reconnectionToken) {
                    //         console.log("⚠️ room.connection.onclose: reconnect", event);
                    //         colyClient.reconnect(this.reconnectionToken);
                    //     } else {
                    //         console.log("⚠️ room.connection.onclose: joinRoomIfInLobby", event);
                    //         this.joinRoomIfInLobby(true)
                    //     }
                    // }
                });
            };

            room.connection.transport.events.onerror = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.transport.events.onerror", event);
                    if (!room._hasLeft) {
                        room._hasLeft = true
                        this.currentRoomId = undefined;
                        if (this.reconnectionToken) {
                            console.warn(new Date(), "⚠️ room.connection.transport.events.onerror: reconnect", event);
                            colyClient.reconnect(this.reconnectionToken);
                        } else {
                            console.warn(new Date(), "⚠️ room.connection.transport.events.onerror: joinRoomIfInLobby", event);
                            this.joinRoomIfInLobby(true)
                        }
                    }
                });
            };

            room.connection.transport.events.onclose = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.transport.events.onclose", event);
                    // if (!room._hasLeft) {
                    //     room._hasLeft = true
                    //     this.currentRoomId = undefined;
                    //     if (this.reconnectionToken) {
                    //         console.log("⚠️ room.connection.transport.events.onclose: reconnect", event);
                    //         colyClient.reconnect(this.reconnectionToken);
                    //     } else {
                    //         console.log("⚠️ room.connection.transport.events.onclose: joinRoomIfInLobby", event);
                    //         this.joinRoomIfInLobby(true)
                    //     }
                    // }
                });
            };

            room.connection.transport.ws.onerror = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.transport.ws.onerror", event);
                    if (!room._hasLeft) {
                        room._hasLeft = true
                        this.currentRoomId = undefined;
                        if (this.reconnectionToken) {
                            console.warn(new Date(), "⚠️ room.connection.transport.ws.onerror: reconnect", event);
                            colyClient.reconnect(this.reconnectionToken);
                        } else {
                            console.warn(new Date(), "⚠️ room.connection.transport.ws.onerror: joinRoomIfInLobby", event);
                            this.joinRoomIfInLobby(true)
                        }
                    }
                });
            };

            room.connection.transport.ws.onclose = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.transport.ws.onclose", event);
                    // if (!room._hasLeft) {
                    //     room._hasLeft = true
                    //     this.currentRoomId = undefined;
                    //     if (this.reconnectionToken) {
                    //         console.log("⚠️ room.connection.transport.ws.onclose: reconnect", event);
                    //         colyClient.reconnect(this.reconnectionToken);
                    //     } else {
                    //         console.log("⚠️ room.connection.transport.ws.onclose: joinRoomIfInLobby", event);
                    //         this.joinRoomIfInLobby(true)
                    //     }
                    // }
                });
            };

            room.connection.onerror = (event) => {
                setTimeout(() => {
                    console.warn(new Date(), "⚠️ room.connection.onerror", event);
                    if (!room._hasLeft) {
                        room._hasLeft = true
                        this.currentRoomId = undefined;
                        if (this.reconnectionToken) {
                            console.warn(new Date(), "⚠️ room.connection.transport.ws.onclose: reconnect", event);
                            colyClient.reconnect(this.reconnectionToken);
                        } else {
                            console.warn(new Date(), "⚠️ room.connection.transport.ws.onclose: joinRoomIfInLobby", event);
                            this.joinRoomIfInLobby(true)
                        }
                    }
                });
            };

            this.attempts = 0;
            this.leaveExistingRoom = async () => {
                // This should now come from the coly backend itself?
                if (this.webhooksService) {
                    this.webhooksService.clearDispatchInterval();
                }
                delete this.webhooksService;

                room.removeAllListeners()
                await room.leave(true);
            }

            this.roomLeavingCallbacks.push({
                roomId: room.id,
                callback: this.leaveExistingRoom
            })

            colyClient.room = {
                ...room,
                send: (sendName, data) => {
                    // console.log(room.roomId, room.connection?.transport?.ws, sendName, data);

                    if (!room.connection?.transport?.ws || room.connection?.transport?.ws.readyState !== WebSocket.OPEN) {
                        console.error('ERROR: WEBSOCKET NOT WORKING', room.roomId);
                        clearInterval(interval)
                        this.currentRoomId = undefined;
                        this.joinRoomIfInLobby(true);

                        return;
                    }

                    room.send(sendName, {
                        ...data,
                        jwt: window.localStorage.getItem('feathers-jwt')
                    })
                }
            }

            async function waitForSchemaReady(schema) {
              while (!schema?.characters?.$changes) {
                await new Promise(r => setTimeout(r, 0));
              }

              await new Promise(r => setTimeout(r, 500));
              return schema;
            }


            this.isInitialised = false;

            // This takes 148ms to execute.
            room.onStateChange.once(async (state) => {
                console.log('start of room.onstatechange: ', new Date().getTime());
                await waitForSchemaReady(room.state);

                if (this.isInitialised) {
                    return;
                }

                // if (this.character) {
                //     if ((state.panel.id !== this.character?.panelId) || (updatedCharacter.z !== this.character?.z)) {
                //         console.log(state.panel.id, 'is character already set, so returning');
                //         return;
                //     }
                // }

                if (updatedCharacter._id !== this.character?._id) {
                    // console.log('NO! DONT DO THIS!', updatedCharacter, this.character);
                    return;
                }

                // Todo - make all of the below code not be blocking somehow...?

                let waitTime = new Date().getTime();

                // TODO - handle updates
                const character = state.characters.find(character => (character._id === updatedCharacter._id))

                this.character = character;

                if (!character){
                    // console.log('could not find character :(')
                    return
                }

                store.dispatch(initialisingPanelStarted())

                this.addToQueue(getCharacterSuccess({ character: { ...character } }))

                store.dispatch(getMessagesAsync({ characterId: character._id }));

                store.dispatch(getCharacterPanelsAsync({ userId: character.userId }));

                this.audioService.setZIndex(updatedCharacter.z);
                this.audioService.setBiome(state.panel?.biome);

                const characterPanel = state.characterPanels?.find(characterPanel => (characterPanel.panelId === this.character.panelId));

                if (characterPanel) {
                    state.panel.characterPanel = characterPanel

                    this.addToQueue(addCharacterPanelSuccess({
                        ...state.panel.characterPanel
                    }))
                }

                this.addToQueue(loadPanelSuccess(state.panel))

                // waitTime = await adaptiveWait(waitTime, 'loadPanelSuccess');

                if (updatedCharacter.z === -1) {
                    this.audioService.setRequiredMood('unsafe')
                } else if (state.characters.length === 1) {
                    this.audioService.setRequiredMood('moderate')
                } else {
                    this.audioService.setRequiredMood('safe')
                }

                this.addToQueue(getCharactersSuccess(state.characters))

                // waitTime = await adaptiveWait(waitTime, 'getCharactersSuccess');

                this.addToQueue(loadTilesSuccess({
                    response: state.tiles.map(tile => ({
                        ...tile,
                        graffiti: tile.graffiti && JSON.parse(LZString.decompressFromUTF16(tile.graffiti)),
                        pixelsArray: tile.pixelsArray && JSON.parse(LZString.decompressFromUTF16(tile.pixelsArray)),
                    })),
                    tileTypes: this.tileTypes
                }))

                // waitTime = await adaptiveWait(waitTime, 'loadTilesSuccess');

                this.addToQueue(loadTilesFinished({ response: [] }));

                // waitTime = await adaptiveWait(waitTime, 'loadTilesFinished');

                this.addToQueue(getPlantsSuccess(
                    state.plants.map(plant => ({
                        ...plant,
                        plant: this.plantTypesDictionary[plant.plantTypeId],
                        plantProducts: this.plantProductsDictionary[plant.plantTypeId]
                    }))
                ))

                // waitTime = await adaptiveWait(waitTime, 'getPlantsSuccess');

                this.addToQueue(getConstructionsSuccess(
                    state.constructions.map(construction => ({
                        ...construction,
                        construction: this.constructionTypes.find(type => type._id === construction.constructionTypeId),    
                        recipes: this.constructionRecipes?.filter(recipe => recipe.constructionTypeId === construction.constructionTypeId),
                        graffiti: construction.graffiti && JSON.parse(LZString.decompressFromUTF16(construction.graffiti)),
                        pixelsArray: construction.pixelsArray && JSON.parse(LZString.decompressFromUTF16(construction.pixelsArray)),
                    }))
                ))

                // waitTime = await adaptiveWait(waitTime, 'getConstructionsSuccess');

                // this.addToQueue(getDeadCharactersSuccess(state.deadCharacters))

                // waitTime = await adaptiveWait(waitTime, 'getDeadCharactersSuccess');

                this.addToQueue(getAnimalsSuccess(
                    state.animals.map(animal => ({
                        ...animal,
                        animal: this.animalTypes.find(type => type._id === animal.animalTypeId)
                    }))
                ))

                // waitTime = await adaptiveWait(waitTime, 'getAnimalsSuccess');

                // this.addToQueue(getWagonsSuccess(
                //     state.wagons.map(wagon => ({
                //         ...wagon,
                //         graffiti: wagon.graffiti && JSON.parse(wagon.graffiti),
                //         pixelsArray: wagon.pixelsArray,
                //         wagonType: this.wagonTypes.find(type => type._id === wagon.wagonTypeId),
                //     }))
                // ));

                // waitTime = await adaptiveWait(waitTime, 'getWagonsSuccess');
                
                this.addToQueue(getWorkshopsSuccess(
                    state.workshops.map(workshop => ({
                        ...workshop,
                        workshopType: this.workshopTypes.find(type => type._id === workshop.workshopTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getWorkshopsSuccess');
                
                // this.addToQueue(getBoatsSuccess(
                //     state.boats.map(boat => ({
                //         ...boat,
                //         graffiti: boat.graffiti && JSON.parse(boat.graffiti),
                //         pixelsArray: boat.pixelsArray,
                //         boatType: this.boatTypes.find(type => type._id === boat.boatTypeId)
                //     }))
                // ));

                // waitTime = await adaptiveWait(waitTime, 'getBoatsSuccess');

                this.addToQueue(getInventorySuccess(
                    state.materials.map(material => ({
                        ...material,
                        materialType: this.materialTypes.find(type => type._id === material.materialTypeId),
                        plant: this.plantTypes.find(type => type._id === material.plantTypeId),
                        animal: this.animalTypes.find(type => type._id === material.animalTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getInventorySuccess');

                this.addToQueue(getFoodSuccess(
                    state.food.map(food => ({
                        ...food,
                        foodType: this.foodTypes.find(type => type._id === food.foodTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getFoodSuccess');

                this.addToQueue(getToolsSuccess(
                    state.tools.map(tool => ({
                        ...tool,
                        toolType: this.toolTypes.find(type => type._id === tool.toolTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getToolsSuccess');
                
                this.addToQueue(getMetalsSuccess(
                    state.metals.map(metal => ({
                        ...metal,
                        metalType: this.metalTypes.find(type => type._id === metal.metalTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getMetalsSuccess');
                
                this.addToQueue(getKeysSuccess(
                    state.keys.map(key => ({
                        ...key,
                        keyType: this.keyTypes.find(type => type._id === key.keyTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getKeysSuccess');

                this.addToQueue(getWritingSurfacesSuccess(
                    state.writingSurfaces.map(writingSurface => ({
                        ...writingSurface,
                        graffiti: writingSurface.graffiti && JSON.parse(LZString.decompressFromUTF16(writingSurface.graffiti)),
                        pixelsArray: writingSurface.pixelsArray && JSON.parse(LZString.decompressFromUTF16(writingSurface.pixelsArray)),
                        writingSurfaceType: this.writingSurfaceTypes.find(type => type._id === writingSurface.writingSurfaceTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getWritingSurfacesSuccess');
                
                this.addToQueue(getWritingImplementsSuccess(
                    state.writingImplements.map(writingImplement => ({
                        ...writingImplement,
                        writingImplementType: this.writingImplementTypes.find(type => type._id === writingImplement.writingImplementTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getWritingImplementsSuccess');

                this.addToQueue(getWeaponsSuccess(
                    state.weapons.map(weapon => ({
                        ...weapon,
                        graffiti: weapon.graffiti && JSON.parse(LZString.decompressFromUTF16(weapon.graffiti)),
                        pixelsArray: weapon.pixelsArray && JSON.parse(LZString.decompressFromUTF16(weapon.pixelsArray)),
                        weaponType: this.weaponTypes.find(type => type._id === weapon.weaponTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getWeaponsSuccess');
                
                this.addToQueue(getArmourSuccess(
                    state.armour.map(armour => ({
                        ...armour,
                        graffiti: armour.graffiti && JSON.parse(LZString.decompressFromUTF16(armour.graffiti)),
                        pixelsArray: armour.pixelsArray && JSON.parse(LZString.decompressFromUTF16(armour.pixelsArray)),
                        armourType: this.armourTypes.find(type => type._id === armour.armourTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getArmourSuccess');

                this.addToQueue(getClothingSuccess(
                    state.clothing.map(clothing => ({
                        ...clothing,
                        graffiti: clothing.graffiti && JSON.parse(LZString.decompressFromUTF16(clothing.graffiti)),
                        pixelsArray: clothing.pixelsArray && JSON.parse(LZString.decompressFromUTF16(clothing.pixelsArray)),
                        clothingType: this.clothingTypes.find(type => type._id === clothing.clothingTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getJewellerySuccess');
                
                this.addToQueue(getMineralsSuccess(
                    {
                        response: state.minerals,
                        mineralTypes: this.mineralTypes
                    }
                ));

                // waitTime = await adaptiveWait(waitTime, 'getMineralsSuccess');

                this.addToQueue(getLocksSuccess(
                    state.locks.map(lock => ({
                        ...lock,
                        lockType: this.lockTypes.find(type => type._id === lock.lockTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getLocksSuccess');
                this.addToQueue(getFurnitureSuccess(
                    state.furniture.map(furniture => ({
                        ...furniture,
                        graffiti: furniture.graffiti && JSON.parse(LZString.decompressFromUTF16(furniture.graffiti)),
                        pixelsArray: furniture.pixelsArray && JSON.parse(LZString.decompressFromUTF16(furniture.pixelsArray)),
                        furnitureType: this.furnitureTypes.find(type => type._id === furniture.furnitureTypeId)
                    }))
                ));

                // waitTime = await adaptiveWait(waitTime, 'getFurnitureSuccess');

                this.addToQueue(getCharacterLevelsSuccess(state.characterLevels))
                // waitTime = await adaptiveWait(waitTime, 'getCharacterLevelsSuccess');

                this.addToQueue(getOrganisationsSuccess(state.organisations))
                // waitTime = await adaptiveWait(waitTime, 'getOrganisationsSuccess');

                this.addToQueue(getOrdersSuccess(state.orders))
                // waitTime = await adaptiveWait(waitTime, 'getOrdersSuccess');

                this.addToQueue(getCompletedOrdersSuccess(state.completedOrders))

                this.addToQueue(getZonesSuccess(state.zones))
                // waitTime = await adaptiveWait(waitTime, 'getZonesSuccess');

                this.addToQueue(getBrainchipsSuccess(state.brainchips.map(brainchip => ({
                    ...brainchip,
                    brainchipType: this.brainchipTypes.find(type => type._id === brainchip.brainchipTypeId)
                }))))

                this.addToQueue(getCriminalsSuccess(state.crimes))

                this.drawMine(state.panel);
                // waitTime = await adaptiveWait(waitTime, 'drawMine');

                if (this.webhooksService) {
                    this.webhooksService.clearDispatchInterval();
                    delete this.webhooksService
                }

                this.webhooksService = new WebhooksService(this.tilemapService, this.audioService, room.id);
                this.webhooksService.watchStateChanges(room.state);
                // waitTime = await adaptiveWait(waitTime, 'watchStateChanges');

                window.roomState = room.state

                store.dispatch(batchActions(this.dispatchQueue))
                this.dispatchQueue = [];

                const storeState = store.getState();
                // This takes 12ms
                await this.tilemapService.triggerInitialDraw(storeState)
                // waitTime = await adaptiveWait(waitTime, 'triggerInitialDraw');

                setTimeout(() => {
                    store.dispatch(updateVisionRadius(new Date().getTime()));
                    store.dispatch(initialisingPanelFinished())

                    this.isInitialised = true;
                });
                // waitTime = await adaptiveWait(waitTime, 'initialisingPanelFinished');

                console.log('end of room.onstatechange: ', new Date().getTime());
            });
        })
        .catch(e => {
            console.log(`JOIN ERROR for panelId ${updatedCharacter.panelId}`, e);
            store.dispatch(connectionError());
            // window.location.reload()
        })
    }

    monitorConnection(room) {
        // console.log('monitoring room: ', room.roomId);
      const transport = room.connection.transport;

      const check = () => {
        const ws = transport.ws;

        // console.log(room.roomId, ws);

        if (!ws) {
            console.warn(new Date(), room.roomId - '⚠️ NO WEBSOCKET!!');
            clearInterval(interval)
            this.currentRoomId = undefined;
            this.joinRoomIfInLobby(true);
            return;
        };

        if (ws.readyState !== WebSocket.OPEN) {
            // console.warn(new Date(), "⚠️ WebSocket not open! State:", ws.readyState);
            if (this.reconnectionToken !== room.reconnectionToken) {
                // console.warn(new Date(), "⚠️ Wrong reconnection token:", this.reconnectionToken, room.reconnectionToken);
                clearInterval(interval)
            }

            if (this.currentRoomId !== room.roomId) {
                // console.warn(new Date(), "⚠️ Wrong roomId:", this.currentRoomId, room.roomId);
                clearInterval(interval)
            }

            if (!room._hasLeft && this.currentRoomId === room.roomId && this.reconnectionToken === room.reconnectionToken) {
                console.warn(new Date(), "⚠️⚠️ Retrying websocket! State:", ws.readyState);
                clearInterval(interval)
                room._hasLeft = true;
                this.currentRoomId = undefined;
                this.joinRoomIfInLobby(true);
            }
        }
      };

      // check every 500 milliseconds
      const interval = setInterval(check, 500);

      // clear it when you actually leave
      room.onLeave(() => clearInterval(interval));

      return interval;
    }


    onDestroy() {
        this.storeSubscription();
    }

    async initialise() {

    }

    clearPreviousPanel() {
        store.dispatch(initialisingPanelStarted())
    }

    drawMine(panel) {
        if (panel) {
            const rng = seedrandom('biome' + panel.x + panel.y);

            if (this.character.z === 0) {
                drawMineEntrance(panel, rng, 0);
                
            } else if (this.character.z < 0) {
                drawMine(panel, rng, this.character.z);
            }
        }
    }
}

export async function adaptiveWait(previousTime, waitString) {
    const currentTime = new Date().getTime();

    const waitMs = 1 * (currentTime - previousTime)

    await sleep(waitMs)

    return new Date().getTime()
}

function sleep(ms) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve('done')
        }, ms)
    })
}

export default PanelInitialisationService;
